module.exports = __webpack_public_path__ + "img/forgot-password.c3b429b5.png";